import styled from "styled-components";
import { Device } from "./Devices";
import BackgroundImage from "../../images/meplug/meplug_bg.jpg";
import BackgroundImagePortrait from "../../images/meplug/meplug_bg_portrait.jpg";

import M from "../../images/M.png";
import MPink from "../../images/M-Pink2.png";

export const Body = styled.div`
  padding-left: ${(props) => (props.isCollapsed ? "80px" : "200px")};
  transition: margin-left 0.3s ease;
  background-color: #14141f;
  height: ${(props) => props.h || "100vh"};
  transition: all 0.3s ease;
  overflow: hidden;

  @media ${Device.mobileS} {
    padding: 0;
    height: auto;
  }

  @media ${Device.mobileM} {
  }

  @media ${Device.mobileL} {
  }

  @media ${Device.tablet} {
  }

  @media ${Device.laptop} {
    padding-left: ${(props) => (props.isCollapsed ? "80px" : "200px")};
  }
`;

export const Background = styled.div`
  background-image: url(${BackgroundImage});
  background-color: rgba(0, 0, 0, 0.5);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-blend-mode: darken;
  filter: blur(3px);
  height: 100vh;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  transform: scale(1.01);
  overflow: hidden;

  &:hover {
    overflow: hidden;
    transform: scale(1.1);
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    height: 100vh;
    background-image: url(${BackgroundImagePortrait});
    &:hover {
      overflow: hidden;
      transform: scale(1.01);
    }
  }
`;

export const LandingBody = styled.div`
  padding: 0 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100vh;
  transition: all 0.3s ease;
  overflow: hidden;

  .left-landing {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .btn {
      background-color: #14141f;
      border: 1px solid #fff;
      color: #fff;
      margin-top: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      text-decoration: none;
      text-align: center;
      font-size: 20px;

      h4 {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        text-decoration: none;
        color: #fff;
      }

      &:hover {
        border-color: #bf3699;
        color: #bf3699;
      }

      @media ${Device.mobileS} {
        font-size: 15px;
        padding: 15px 30px;
      }

      @media ${Device.laptopL} {
        font-size: 20px;
        padding: 15px 30px;
      }

      @media ${Device.desktop} {
        font-size: 25px;
        padding: 30px 60px;
      }
    }

    h1 {
      margin: 0;
      color: #fff;

      @media ${Device.mobileS} {
        font-size: 30px;
      }

      @media ${Device.laptopL} {
        font-size: 60px;
      }

      @media ${Device.desktop} {
        font-size: 80px;
      }
    }

    h2 {
      margin: 0;
      color: #fff;
      font-size: 80px;
      @media ${Device.mobileS} {
        font-size: 40px;
      }

      @media ${Device.laptopL} {
        font-size: 70px;
      }

      @media ${Device.desktop} {
        font-size: 100px;
      }
    }

    h3 {
      color: #fff;
      font-weight: 400;

      @media ${Device.mobileS} {
        font-size: 15px;
      }

      @media ${Device.laptopL} {
        font-size: 20px;
      }

      @media ${Device.desktop} {
        font-size: 30px;
      }
    }
  }

  .right-landing {
    background-color: #3d308b;
    width: 500px;
    height: 120vh;
    transform: rotate(14.37deg);
    z-index: 1;
    margin: 0;

    .right-landing-inner {
      z-index: 2;
      background-image: url(${M});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-14.37deg);
      transition: all 0.3s ease;

      &:hover {
        background-image: url(${MPink});
        transform: translate(-50%, -50%) rotate(-14.37deg) scale(1.1);
      }

      @media ${Device.tablet} {
        width: 200px;
        height: 200px;
      }

      @media ${Device.laptop} {
        width: 250px;
        height: 250px;
      }

      @media ${Device.laptopL} {
        width: 400px;
        height: 400px;
      }
    }


    @media ${Device.tablet} {
      width: 200px;
    }

    @media ${Device.laptop} {
      width: 270px;
    }

    @media ${Device.laptopL} {
      width: 450px;
      height: 120vh;
    }
  }

  @media ${Device.mobileS} {
    padding: 0px 20px;

    .right-landing {
      visibility: hidden;
      display: none;
      z-index: -1;
    }
  }

  @media ${Device.tablet} {
    padding: 0 20px;
    .right-landing {
      visibility: visible;
      display: flex;
      z-index: 0;
    }
  }

  @media ${Device.laptop} {
    padding: 0px 80px;

    .right-landing {
      visibility: visible;
    }
  }
`;

export const ProjectBody = styled.div`
  padding: 0px 80px;
  overflow: hidden;

  h2 {
    font-size: 80px;
    color: ${(props) => props.color || "white"};
    margin-top: 0;
    margin-bottom: 20px;

    @media ${Device.mobileS} {
      font-size: 40px;
    }

    @media ${Device.laptop} {
      font-size: 50px;
    }

    @media ${Device.laptopL} {
      font-size: 65px;
    }
  }

  p {
    font-size: 1rem;
    color: white;
    font-weight: 300;
    padding-bottom: ${(props) => props.pb};

    @media ${Device.mobileS} {
      font-size: 10px;
    }

    @media ${Device.laptop} {
      font-size: 13px;
    }

    @media ${Device.laptopL} {
      font-size: 16px;
    }
  }

  .right-image {
    padding-top: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;

    p {
      padding-bottom: 30px;
    }

    img {
      width: 250px;
      height: auto;

      @media ${Device.laptop} {
        width: 250px;
      }

      @media ${Device.laptopL} {
        width: 300px;
      }
    }
  }

  @media ${Device.mobileS} {
    padding: 20px 20px 0px 20px;
  }

  @media ${Device.laptop} {
    padding: 0px 100px;
  }
`;

export const Content = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: ${(props) => props.size || "80px"};
  color: ${(props) => props.color || "white"};
  margin-top: 0;
  margin-bottom: 0;
`;

export const Map = styled.iframe`
  width: 700px;
  height: 700px;
  border: 0;
`;

export const Box = styled.div`
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 30px;
  margin: 10px;
  width: 502px;
  background-color: #f2f2f2;
  color: #000;
  letter-spacing: 1px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    transform: translateY(-5px);
  }
`;

export const SkillBody = styled.div`
  padding: 0px 80px;
  overflow: hidden;

  h2 {
    font-size: 80px;
    color: ${(props) => props.color || "white"};
    margin-top: 0;
    margin-bottom: 20px;

    @media ${Device.mobileS} {
      font-size: 40px;
      text-align: center;
    }

    @media ${Device.mobileL} {
      font-size: 55px;
      text-align: center;
      margin-bottom: 0;
    }

    @media ${Device.tablet} {
      font-size: 65px;
    }

    @media ${Device.laptop} {
      font-size: 45px;
    }
    @media ${Device.laptopL} {
      font-size: 60px;
    }

    @media ${Device.desktop} {
      font-size: 70px;
    }
  }

  p {
    font-size: 1rem;
    color: white;
    font-weight: 300;
    padding-bottom: ${(props) => props.pb};

    @media ${Device.laptop} {
      font-size: 12px;
    }

    @media ${Device.laptopL} {
      font-size: 18px;
    }

    @media ${Device.desktop} {
      font-size: 25px;
    }
  }

  .card {
    background-color: #242424;
    transition: all 0.3s ease;

    h3 {
      color: white;
      font-size: 1.5rem;
      margin-top: 0;
      margin-bottom: 10px;

      @media ${Device.laptop} {
        font-size: 1rem;
      }

      @media ${Device.laptopL} {
        font-size: 1.6rem;
      }

      @media ${Device.desktop} {
        font-size: 2rem;
      }
    }

    h6 {
      color: white;
      font-size: 1vw;
      font-weight: 300;
      margin-top: 0;

      @media ${Device.mobileS} {
        font-size: 15px;
      }

      @media ${Device.laptop} {
        font-size: 11px;
      }

      @media ${Device.laptopL} {
        font-size: 16px;
      }

      @media ${Device.desktop} {
        font-size: 20px;
      }
    }

    &:hover {
      box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.4);
      transform: translateY(-5px);
    }
  }

  @media ${Device.mobileS} {
    padding: 60px 20px;
  }

  @media ${Device.laptop} {
    padding: 0px 60px;
  }
`;
